import { render, staticRenderFns } from "./LinkToCofelyVision.vue?vue&type=template&id=58851bd8&scoped=true"
import script from "./LinkToCofelyVision.vue?vue&type=script&lang=js"
export * from "./LinkToCofelyVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58851bd8",
  null
  
)

export default component.exports